import React from "react";
import { Link } from "react-router-dom";
import LinkHome from "../shared/LinkHome";
import "./Work.css";
import { motion } from "framer-motion";

const Work = () => {
  return (
    <>
      <section className="works">
        <div className="worksContainer">
          <motion.div
            transition={{ duration: 0.2 }}
            animate={{ y: 0, opacity: 1 }}
            initial={{ y: 100, opacity: 0 }}
            className="workContent"
          >
            <Link>
              <div>
                <h2>Locals LiftOff</h2>
                <p>SEO Service</p>
              </div>
            </Link>
            <a href="work/watch">
              <div>
                <h2>Watch Station</h2>
                <p>E-commerce</p>
              </div>
            </a>
            <Link>
              <div>
                <h2>Doctors Portal</h2>
                <p>Product for Doctor Appointment</p>
              </div>
            </Link>
            <Link>
              <div>
                <h2>Ace Holidays</h2>
                <p>Hotel Room Booking</p>
              </div>
            </Link>
          </motion.div>
        </div>
        <LinkHome color={"white"} />
      </section>
    </>
  );
};

export default Work;
